import React from "react";
import "./header.css";
import { makeStyles } from "@material-ui/core/styles";

import BellLogo from "../common/icons/bellLogo";
import { AppBar } from "@material-ui/core";

export const useActionStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    menuButton: {
        height: "100%",
        width: "40px",
        border: "none",
        padding: "17.5px 8px 14.5px",
        backgroundColor: "unset",
        "&:focus": {
            border: "none",
            backgroundColor: "unset",
            outline: "none",
        },
    },
}));

export const MainHeader = (props) => {
    const { subtitle, boxShadow } = props;
    const actions = [...props.actions].reverse();
    const classes = useActionStyles();

    return (
        <div className={"m-app-nav-bell no-print" + (boxShadow ? " box-shadow" : "") + (props.withSidebar ? " with-sidebar" : "")}>
            <ul>
                <li className="header-left logo">
                    <BellLogo color="white" />
                </li>
                <ul className="header-left title">
                    <li className="header-bottom subtitle">{subtitle}</li>
                </ul>
                {actions.map((action, i) => (
                    <li key={i} className="header-right">
                        {action}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MainHeader;
